import axios from "axios";
import client from "./client";
import Cookies from "js-cookie";
import ToastMessage from "../common/ToastMessage";
import { Token } from "../domain/helpers/Token";
import { StorageItems } from "../utils/storageItems";
import { UserLogin } from "../domain/helpers/UserLogin";
import { UserRegisterInterface } from "../domain/helpers/UserRegister";
import { UserResetPassword } from "../domain/helpers/UserResetPassword";

const endPoint = "/api/login";

const refreshTokenApiCall = async (
  token: string,
  refreshToken: string
): Promise<Token | null> => {
  try {
    const response = await axios.post<Token>(`/api/account/refreshtoken`, {
      token,
      refreshToken,
    });
    console.log("response ===", response);
    return response.data;
  } catch (error) {
    Cookies.remove(StorageItems.TOKEN);
    Cookies.remove(StorageItems.REFRESHTOKEN);
    window.location.href = "/login";
    return null;
  }
};

const loginUser = async (user: UserLogin) => {
  try {
    const { data } = await axios.post(
      `${endPoint}`,
      { ...user },
      {
        withCredentials: true,
      }
    );
    return data;
  } catch (error) {
    if (error instanceof Error) {
      //ToastMessage.Failed(`Error: ${error.message}`);
    }
    throw error; // Propagate the error
  }
};

const registerUser = async (register: UserRegisterInterface) => {
  try {
    const response = await axios.post(`/api/account/register`, { ...register });
    return response;
  } catch (error: any) {
    if (error instanceof Error) {
      ToastMessage.Failed(`Error: ${error.message}`);
    }
    throw error;
  }
};

const forgetPassword = async (email: string) => {
  try {
    const response = await axios.post(`api/account/ForgetPassword`, { email });
    return response;
  } catch (error) {
    if (error instanceof Error) {
      ToastMessage.Failed(`Error: ${error.message}`);
    }
    throw error;
  }
};

const confirmEmail = async (userId: string, token: string) => {
  try {
    const response = await axios.get(
      `/api/users/confirm-email?userId=${userId}&token=${token}`
    );
    return response;
  } catch (error) {
    if (error instanceof Error) {
      ToastMessage.Failed(`Error: ${error.message}`);
    }
    throw error;
  }
};

const sendEmailConfirmation = async (email: string) => {
  try {
    const response = await client.post(`/api/Users/SendEmailConfirmation`, {
      email,
    });
    return response;
  } catch (error) {
    if (error instanceof Error) {
      ToastMessage.Failed(`Error: ${error.message}`);
    }
    throw error;
  }
};

const resetPassword = async (form: UserResetPassword) => {
  try {
    await axios.post(`/api/Account/SetNewPassword`, {
      ...form,
    });
  } catch (error) {
    if (error instanceof Error) {
      ToastMessage.Failed(`Error: ${error.message}`);
    }
    throw error;
  }
};

export {
  loginUser,
  registerUser,
  refreshTokenApiCall,
  forgetPassword,
  resetPassword,
  sendEmailConfirmation,
  confirmEmail,
};
